import { render } from "./HomePag.vue?vue&type=template&id=2a00e9f0"
import script from "./HomePag.vue?vue&type=script&lang=js"
export * from "./HomePag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__